<template>
        <div class="row inline q-pa-sm">
        <app-checkbox-input
        :loadingData="loadingData"
        :value="value.noText"
        :disable="readonly"
        @input="handleChangeInput({ name: 'noText', model: $event })"
        label="No Text"
        class="q-mr-md"
        />
        <app-checkbox-input
        :loadingData="loadingData"
        :value="value.noEmail"
        :disable="readonly"
        @input="handleChangeInput({ name: 'noEmail', model: $event })"
        label="No Email"
        class="q-mx-md"
        />
        <app-checkbox-input
        :loadingData="loadingData"
        :value="value.noVm"
        :disable="readonly"
        @input="handleChangeInput({ name: 'noVm', model: $event })"
        label="No VM"
        class="q-mx-md"
        />
    </div>
</template>
<script>
import AppCheckboxInput from '@client/components/form/checkbox-input';

export default {
  name: 'AppCustomerMessagingOptions',
  components: {
    AppCheckboxInput
  },
  props: {
    loadingData: {
      type: Boolean,
      default: false
    },
    value: Object,
    readonly: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {

    };
  },
  methods: {
    handleChangeInput(value) {
      const { name, model } = value;
      this[name] = model;
        this.$emit('input', {
          ...this.value,
          [name]: model
        });
    }
  }
};
</script>
